import { acceptNumberValue } from '../../field-viewer/shared-normalizers';
export const dextNumberInputViewer = {
    normalizeLoadedValue: acceptNumberValue
};

//# sourceMappingURL=definition-viewer.js.map